interface ICell {
  id: string;
  label: string;
  useSort: boolean;
  width?: number;
}

export const headCells: ICell[] = [
  {
    id: '',
    label: '',
    useSort: false,
    width: 50,
  },
  {
    id: 'eventId',
    label: 'Event',
    useSort: true,
  },
  {
    id: 'patientFullName',
    label: 'Patient',
    useSort: true,
  },
  {
    id: 'messageTimestamp',
    label: 'Date & Time',
    useSort: true,
  },
  {
    id: 'programName',
    label: 'Program',
    useSort: true,
  },
  {
    id: 'facility',
    label: 'Facility',
    useSort: true,
  },
  {
    id: 'reason',
    label: 'Reason',
    useSort: true,
  },
];

export default {};
